import React, { useState, useEffect } from "react";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import { ReactComponent as Unchecked } from "../../assets/analyse/Unchecked.svg";
// import { columnsNames } from "../../css/columns";
// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
// import impact_indicators from "../../app_data/impact_indicators/impactIndicators.json";
import { Number } from "react-intl-number-format";
import { NumericFormat } from "react-number-format";
import { updateQuantityTableLocal, updateQuantityTable } from "../../redux/actions/analysisActions";

import { getFormatedValue } from "../../utils/utils.js";

const ReduceLineColumns = ({ columns, quantity, quantityUnit, impactt, totalScore, ingredient_id, impact_factors, checked, step, line_index, flow_id, conversion_factor, is_reduce }) => {
  // var percentage = impact + "%";

  const [timer, setTimer] = useState(null);

  // REDUX
  const dispatch = useDispatch();
  const updateQuantityTable_rd = (item) => dispatch(updateQuantityTable(item));
  const updateQuantityTableLocal_rd = (item) => dispatch(updateQuantityTableLocal(item));
  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  const optimization_data = useSelector((state) => state.optimization.optimization_data, shallowEqual);
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));

  const handleOnChangeQuantity = (event, previous_quantity) => {
    const item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      quantity: event.target.value, // acutual quantity value
      previous_quantity: previous_quantity,
      type: "flow_quantity",
    };
    updateQuantityTableLocal_rd(item);
    clearTimeout(timer);
    const timeoutId = setTimeout(() => {
      updateQuantityTable_rd(item);
    }, 1000);
    setTimer(timeoutId);
  };

  const impact = ((impact_factors.find((x) => x.id === "da32f256-618d-4bec-a8d9-205817788b26").coefficient * quantity * conversion_factor) / totalScore) * 100;

  return (
    <>
      {/* <p
        onClick={() => {
          console.log(is_reduce, flow_id, columns, quantity, quantityUnit, impact_factors, checked, step, line_index);
          console.log("impactt", quantity, conversion_factor);
        }}
      >
        REDUCE_LINE_RIGHT
      </p> */}

      <div
        key={"reducelinecolumn" + "quantity" + Math.random()}
        className={"flex grid grid-cols-[70px_40px] justify-center items-center h-[40px] w-[140px] border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular"}
      >
        <div>
          <input
            
            disabled={true}
            type="number"
            className="w-[60px] bg-transparent text-right flex mr-1"
            // onChange={(event) => handleOnChangeQuantity(event, quantity)}
            value={quantity}
            onWheel={(e) => e.target.blur()}
          />{" "}
        </div>
        <div>{quantityUnit}</div>
      </div>

      <div
        key={"reducelinecolumn" + "impact_percent" + Math.random()}
        className={`flex justify-evenly items-center h-[40px]  w-[140px]  border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular`}
      >
        <div className="h-[40px] w-[54.5px] flex justify-end items-center">
          <p className="mr-[10px]">{impact && impact.toFixed(2)}</p>
        </div>
        <div className="w-[60px] h-[5px] bg-[#BEC4CA]/50 rounded-xl mr-[5px] flex justify-start">
          <div style={{ width: impact }} className={`w-[${impact}%] h-[5px] rounded-xl bg-[#BEC4CA]`} />
        </div>
      </div>

      {columns.map((current, i) => {
        const indicator_impact = (impact_factors.find((x) => x.id === current).coefficient * quantity * conversion_factor).toFixed(3);
        const ref_indicator = impact_indicators.find((target) => target.id === current);
        const indicator_unit = ref_indicator.ref_unit;
        const width = ref_indicator.width;
        return (
          <>
            <div
              key={"reducelinecolumnn" + `${current + i}` + Math.random()}
              className={`flex justify-center items-center h-[40px]  w-[${width}px]  border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular`}
            >
              {indicator_impact} {" " + indicator_unit}
            </div>
          </>
        );
      })}

      <div
        key={"reducelinecolumn" + "validate" + Math.random()}
        className={`flex justify-center items-center h-[40px]  w-[100px] border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular`}
      >
        <button className="cursor-default">{checked ? <Checked height={30} /> : <Unchecked height={30} />}</button>
      </div>
    </>
  );
};

export default ReduceLineColumns;
